import Mapper from '@/models/mappers/Mapper';
import { ProductionTimeDTO } from '@/api/dto/ProductionTimeDTO';
import { mapValueToInterface } from '@/utils/models';
import { ProductionTime } from '@/models/entities/ProductionTime';

export class ProductionTimeMapper extends Mapper<ProductionTime, ProductionTimeDTO> {
  mapFromDTO(productionTimeDTO: ProductionTimeDTO): ProductionTime {
    return new ProductionTime(<Partial<ProductionTime>>productionTimeDTO);
  }

  mapToDTO(productionTime: ProductionTime): ProductionTimeDTO {
    return mapValueToInterface(productionTime) as ProductionTimeDTO;
  }
}
